import { z } from 'zod';

export const regionTagSchema = z.enum(['major_city', 'sea_port', 'inland_port', 'warehouses_hub']);
export type RegionTag = z.infer<typeof regionTagSchema>;
